export default __webpack_public_path__ + "static/mf-d19de65f075c7de42f4d34a467b4f95a.svg";